import InvoicesService from '@/services/invoices.service';
import instance from "@/http";

function getFilters(data) {
	return Object.keys(data).reduce((acc, item) => {
		if (item.includes('filter')) {
			acc[item] = data[item];
		}

		return acc;
	}, {});
}

export default {
	state: {
		dataPaid: undefined,
		summ: null,
		filtersInvoices: null,
		invoice: [],
		totals: null,
		invoiceEmail: []
	},
	getters: {
		getSumm: s => s.summ,
		filtersInvoices: s => s.filtersInvoices,
		invoice: s => s.invoice,
		getDataPaid: s => s.dataPaid,
		invoiceEmail: s => s.invoiceEmail,
		totals: s => s.totals
	},
	mutations: {
		updateEditInvoices(state, { index, line }) {
			state.invoice.splice(index, 1, line);
		},
		updateRemoveInvoices(state, payload) {
			state.invoice.splice(payload, 1);
		},
		SET_DATA_PAID(state, payload) {
			state.dataPaid = payload;
		},
		SET_SUMM(state, payload) {
			state.summ = payload;
		},
		updateInvoices(state, payload) {
			const { invoice, filters, totals } = payload;
			state.filtersInvoices = getFilters(filters);
			state.invoice = invoice;
			state.totals = totals;
		},
		updateInvoice(state, { invoice, invoice_id }) {
			const idx = state.invoice.findIndex(item => item.invoice_id === invoice_id);
			state.invoice.splice(idx, 1, invoice);
		},
		updateInvoiceEmail(state, payload) {
			state.invoiceEmail = payload;
		}
	},
	actions: {
		async getInvoiceEmail({ commit }, values) {
			try {
				const { data } = await instance().post('invoice/invoiceEmail', { invoice: values });
				if (data && !data.error) {
					commit('updateInvoiceEmail', data.invoices);
				} else {
					console.error('Something went wrong!');
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onSendEmailInvoices({ dispatch }, values) {
			try {
				const { data } = await instance().post('invoice/sendInvoices', values);
				if (data && !data.error) {
					dispatch('getInvoices');
					dispatch('setAlert', { type: "success", message: "Invoices sent successfully" });
				} else {
					console.error('Something went wrong!');
					dispatch('setAlert', { type: "error", message: "Invoices not sent" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		onEditInvoices({ commit }, values) {
			commit('updateEditInvoices', values);
		},
		onRemoveInvoices({ commit }, index) {
			commit('updateRemoveInvoices', index);
		},
		onMathSum({ commit }, payload) {
			commit("SET_SUMM", payload);
		},
		async getInvoices({ commit }, payload) {
			try {
				return await InvoicesService.getInvoices(payload).then((result) => {
					if (result.status) {
						commit('updateInvoices', result.data);
					}
				}).catch((err) => err);

			} catch (error) {
				return error;
			}
		},
		async getInvoice(context, payload) {
			return await InvoicesService.getInvoice(payload).then((result) => result.data).catch((err) => err);
		},
		async setInvoice(context, payload) {
			return await InvoicesService.setInvoice(payload).then((result) => result.data).catch((err) => err);
		},
		async setPayment(context, payload) {
			return await InvoicesService.setPayment(payload).then(result => result).catch(err => err);
		},
		async getDataPaid({ commit }, payload) {
			try {
				const data = await InvoicesService.getDataPaid(payload);
				data.data.note = '';
				if (data.data) commit('SET_DATA_PAID', data.data);
			} catch (error) {
				console.error(error);
			}
		},
		deletedInvoice(context, payload) {
			return InvoicesService.deletedInvoice(payload).then(result => result).catch(err => err);
		},
		sendInvoice(context, payload) {
			return InvoicesService.sendInvoice(payload).then(result => result).catch(err => err);
		},
		async paidInvoice(context, payload) {
			try {
				const data = await InvoicesService.paidInvoice(payload);
				if (data.data.status === true) return data.data.invoice[0];
			} catch (error) {
				console.error(error);
			}
		}
	}
};
